import React, { useState, useEffect } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action.js";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css.js";
import "../../../stylesheets/simulateursBis.css";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import TextfieldNumber from "../../../components/textfields/textfield.number.js";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle.js";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso.js";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques.js";
import {useSnackbar} from "notistack";
import SelectDepartement from "../../../components/selects/select.departement";
import PrimoAccedant from "../../../components/questions/PrimoAccedant";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires.js";
import DeboursQuestion from "../../../components/questions/DeboursQuestion.js";
import ButtonTextCustom from "../../../components/buttons/button.text.custom.js";
import Promesse from "../../../components/questions/Promesse.js";
import Pret from "../../../components/questions/Pret.js";

// Vente en viager (libre ou occupé)
// simulateur id 117

function Simulateur_117(props) {
  const dispatch = useDispatch();
  const {enqueueSnackbar} = useSnackbar();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }
  
  const [departement, setDepartement] = useState(1);
  const [departementChiffre, setDepartementChiffre] = useState(0);
  const [primoAccedant, setPrimoAccedant] = useState(0);
  const [taxeIleDeFrance, setTaxeIleDeFrance] = useState(0);
  const [zrr, setZrr] = useState(0);
  const [travaux_entretient_annuel, setTravauxEntretient] = useState(0);
  const [taxeFonciere, setTaxeFonciere] = useState(0);
  const [taxeLogementVacant, setTaxeLogementVacant] = useState(0);
  const [fractionFondTravauxCharges, setFractionFondTravaux] = useState(0);
  const [valeurLocativeBrute, setValeurLocativeBrute] = useState(0);
  const [cautionSansGarantieHypo, setCautionSansGarantieHypo] = useState(0);
  const [simu114, setSimu114] = useState(null);
  const [montantVente, setMontantVente] = useState(0);
  const [typeViager, setTypeViager] = useState(0);
  const [usufruitierSuccessif, setUsufruitierSuccessif] = useState(0);
  const [esperanceVieUsufruitier, setEsperanceVieUsufruitier] = useState(0);
  const [esperanceVieUSSuccessif, setEsperanceVieUSSuccessif] = useState(0);
  const [montantBouquet, setMontantBouquet] = useState(0);
  const [choixReserveUsage, setChoixReserveUsage] = useState(1);
  const [valeurFiscalNP, setValeurFiscalNP] = useState(0);
  const [promesse, setPromesse] = useState(0);
  const [montantPromesse, setMontantPromesse] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [pretsPro, setPretsPro] = useState(0);
  const [simu84, setSimu84] = useState(null);
  const [simu92, setSimu92] = useState(null);

  const [dependances, setDependancesState] = useState([]);
  
  useEffect(() => {
    if (simu84 !== undefined && simu84 !== null) setDependances(simu84);
  }, [simu84]);

  useEffect(() => {
    if (simu92 !== undefined && simu92 !== null) setDependances(simu92);
  }, [simu92]);

  useEffect(() => {
    if (simu114 !== undefined && simu114 !== null) setDependances(simu114);
  }, [simu114]);

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  const handleChange = async (setter, value, key) => {
    
    if (setter === setMontantVente || setter === setValeurLocativeBrute || setter === setEsperanceVieUsufruitier || setter === setTravauxEntretient || setter === setTaxeFonciere || setter === setTaxeLogementVacant || setter === setFractionFondTravaux) {
      if (parseInt(value) < 0) {
        enqueueSnackbar("La valeur ne peut pas être négative.", { variant: "error" });
        return;
      } 
    }  
    if (setter === setDepartementChiffre) {
      if (!props.depsPrimoAccedants.includes(value)) {
        setPrimoAccedant(0);
      }
      setDepartementChiffre(value);
    } else {
        setter(value);
        setInRedux(setter, value, key )
    }
  };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

  function setInRedux(setter, value, key) {
    
    let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),  
        inputs: {
            primo_accedant: parseInt(primoAccedant),
            taxe_ile_de_france: parseInt(taxeIleDeFrance),
            zrr: parseInt(zrr),
            travaux_entretient_annuel: parseInt(travaux_entretient_annuel),
            taxe_fonciere: parseInt(taxeFonciere),
            taxe_logement_vacant: parseInt(taxeLogementVacant),
            fraction_fond_travaux_charges: parseInt(fractionFondTravauxCharges),
            valeur_locative_brute: parseInt(valeurLocativeBrute),
            montant_vente: parseInt(montantVente),
            type_viager: parseInt(typeViager),
            usufruitier_successif: parseInt(usufruitierSuccessif),
            esperance_vie_usufruitier: parseInt(esperanceVieUsufruitier),
            esperance_vie_us_successif: parseInt(esperanceVieUSSuccessif),
            montant_bouquet: parseInt(montantBouquet),
            reserve: parseInt(choixReserveUsage),
            np_fiscale: parseInt(valeurFiscalNP),
            promesse: parseInt(promesse),
            montant_promesse: parseInt(montantPromesse),
            montant_deb_add: parseInt(montantDeboursAdditionnels),
            debours_additionnels: parseInt(deboursAdditionnels),
            convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
            nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
            object_convention_honoraires : props.objectConventionHonoraires,
            montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
            nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
            adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
        dependances: dependances,
    };
    //For values coming from components
    if (key) {
        if (key === "debours_additionnels") {
            if (value === 0) {
                setMontantDeboursAdditionnels(0)
                Object.assign(object["inputs"], { montant_deb_add: 0 });
            }
            Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "promesse") {
            if (value === 0) {
                setMontantPromesse(0)
                Object.assign(object["inputs"], { montant_promesse: parseInt(0) });
            }
            Object.assign(object["inputs"], { promesse: parseInt(value) });
        }
        if (key === "montant_deb_add") { Object.assign(object["inputs"], { montant_deb_add: parseInt(value) }); }
        if (key === "montant_promesse") { Object.assign(object["inputs"], { montant_promesse: parseInt(value) }); }
        if (key === "primo_accedant") { Object.assign(object["inputs"], { primo_accedant: parseInt(value) }); }
    }

    //For internal settings
    if (setter === setDepartement) { object.departementid = parseInt(value); }
    if (setter === setTaxeIleDeFrance) { Object.assign(object["inputs"], { taxe_ile_de_france: parseInt(value) }); }
    if (setter === setZrr) { Object.assign(object["inputs"], { zrr: parseInt(value) }); }
    if (setter === setTravauxEntretient) { Object.assign(object["inputs"], { travaux_entretient_annuel: parseInt(value) }) }
    if (setter === setTaxeFonciere) { Object.assign(object["inputs"], { taxe_fonciere: parseInt(value) }) }
    if (setter === setTaxeLogementVacant) { Object.assign(object["inputs"], { taxe_logement_vacant: parseInt(value) }) }
    if (setter === setFractionFondTravaux) { Object.assign(object["inputs"], { fraction_fond_travaux_charges: parseInt(value) }) }
    if (setter === setValeurLocativeBrute) { Object.assign(object["inputs"], { valeur_locative_brute: parseInt(value) }) }
    if (setter === setMontantVente) { Object.assign(object["inputs"], { montant_vente: parseInt(value) }) }
    if (setter === setEsperanceVieUsufruitier) { Object.assign(object["inputs"], { esperance_vie_usufruitier: parseInt(value) }) }
    if (setter === setEsperanceVieUSSuccessif) { Object.assign(object["inputs"], { esperance_vie_us_successif: parseInt(value) }) }
    if (setter === setMontantBouquet) { Object.assign(object["inputs"], { montant_bouquet: parseInt(value) }) }
    if (setter === setValeurFiscalNP) { Object.assign(object["inputs"], { np_fiscale: parseInt(value) }); }
    if (setter === setTypeViager) { 
        Object.assign(object["inputs"], { type_viager: parseInt(value) }) 
        if (value === 0) { 
            setUsufruitierSuccessif(0); 
            Object.assign(object["inputs"], { usufruitier_successif: 0 }) 
            setEsperanceVieUSSuccessif(0);
            Object.assign(object["inputs"], { esperance_vie_us_successif: 0 })
            setChoixReserveUsage(1);
            Object.assign(object["inputs"], { reserve: 1 }); 
            setValeurFiscalNP(0)
            Object.assign(object["inputs"], { np_fiscale: 0 });
        }
    }
    if (setter === setUsufruitierSuccessif) { 
        Object.assign(object["inputs"], { usufruitier_successif: parseInt(value) }) 
        if (value === 0) {
            setEsperanceVieUSSuccessif(0);
            Object.assign(object["inputs"], { esperance_vie_usufruitier: 0 })
        }
    }
    if (setter === setChoixReserveUsage) { 
        Object.assign(object["inputs"], { reserve: parseInt(value) }); 
        if (value === 1) {
            setValeurFiscalNP(0)
            Object.assign(object["inputs"], { np_fiscale: 0 });
        }
    }
    
    if (setter === props.setConventionHonoraires) {
        if(value === 0){
            props.setNombreConventionHonoraires(1);
            props.setObjectConventionHonoraires(null);
            props.setMontantConventionHonoraires(null);
            props.setNomSignataireConventionHonoraires(null);
            props.setAdresseSignataireConventionHonoraires(null);
            Object.assign(
                object["inputs"], { convention_honoraires : parseInt(value) },
                object["pdfInputs"], {
                    nombre_convention_honoraires : null,
                    object_convention_honoraires : null,
                    montant_convention_honoraires : null,
                    nom_signataire_convention_honoraires : null,
                    adresse_signataire_convention_honoraires : null
                },
            );
        } else {
            Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
    }

    if (setter === props.setNombreConventionHonoraires) { Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) }); }
    if (setter === props.setObjectConventionHonoraires) { Object.assign(object["pdfInputs"], { object_convention_honoraires : value }); }
    if (setter === props.setMontantConventionHonoraires) { Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)}); }
    if (setter === props.setNomSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value }); }
    if (setter === props.setAdresseSignataireConventionHonoraires) { Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value }); }

    if( setter === setCautionSansGarantieHypo && value === 1) {
        setPretHypo(0);
        setPretsPro(0);
        setSimu84(null);
        setSimu92(null);
        setDependancesState([]);
        object.dependances = [];
    }

    if (setter === setCautionSansGarantieHypo && value === 0) {
        setSimu114(null);
        setDependancesState([]);
        object.dependances = [];
    }
    
    if (setter === "dependance") {
        if (dependances.length > 0) object.dependances = dependances;

        if (value !== undefined) {
            let validator = false;

            for (let i = 0; i < object["dependances"].length; i++) {
                if (object["dependances"][i]?.simulateurid === value.simulateurid) {
                    object.dependances[i] = value;
                    validator = true;
                }
            }

            if (validator === false) {
                object.dependances.push(value);
            }

            setDependancesState(object.dependances);
        }
    }
    
        
    if (setter === setPretHypo && value === 0) {
        setSimu84(null);
        setSimu92(null);
        setDependancesState([]);
        object.dependances = [];
    }
    if (setter === setPretsPro && value === 0) {
        setSimu84(null);
        setDependancesState([]);
        object.dependances = [];
    } else if (setter === setPretsPro && value === 1) {
        setSimu92(null);
        setDependancesState([]);
        object.dependances = [];
    }
        
    if (props.isParent) {
        dispatch(setSimulateurObject(object));
    } else {
        // process child simu
    }
    }

  return (
    <div style={styles.container}>
        <div className="cardSimulateur">
            <TextSimulateurTitle 
                title={props.simulateur.name} 
                currentSimuId={props.simulateur.id}
                tooltipPerso={
                    "En pratique, l’évaluation du prix de cession et de la rente viagère s’opère souvent au moyen du barème Daubry. " + 
                    "Il présente l’avantage d’être facile d’emploi tout en indiquant des espérances de vie par couple, ce que les tables de l’INSEE ne prévoient pas. " +
                    "En revanche, il comporte des imperfections sur le plan économique, notamment parce qu’il indique que le droit d’usage a une valeur supérieure à l’usufruit ou qu’il fixe des taux de rente viagère arbitraires."
                }
            />
            <TextfieldRemarques handleChange={handleChangeRemarque}/>

            <p style={styles.cardSubTitle}>
                Pour la vente, acte tarifé au titre du Tableau 5, n° 54 (Art A444-91). Prêt aux particuliers associé acte
                tarifé au titre du Tableau 5, n° 137 (Art A444-143). Prêt aux professionnels associé acte tarifé au titre du
                Tableau 5, n° 128 (Art A444-139). Cautionnement associé acte tarifé au titre du Tableau 5, n° 111 (Art
                A444-127).
            </p>

            {props?.isParent === true && props.departements !== "" ? (
                <>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Département :</div>

                        <SelectDepartement
                            items={props.departements}
                            nameField={"name"}
                            defaultValue={currUserDep}
                            optionValue={"id"}
                            handleChange={handleChange}
                            setter={setDepartement}
                            setDepartementChiffre={setDepartementChiffre}
                        />
                    </div>
                    <div style={styles.cardRowSpecialMessage}>
                        La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
                    </div>
                </>
            ) : (
                <></>
            )}

            {props.depsTaxeIleFrance.includes(departement) ? (
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Mutation soumise à la taxe additionnelle de 0.6% selon l'article 1599 sexies du CGI ?
                        <ToolTipPerso
                            title={
                            "Attention : Cette taxe ne s’applique que dans certains cas. Se référer au texte en vigueur qui les précise : art 1599 sexies du CGI. \n" +
                            "Taxe additionnelle aux droits d'enregistrement ou à la taxe de publicité foncière exigible sur les mutations à titre onéreux de locaux mentionnés à l'article L. 520-1 du code de l'urbanisme et situés en IDF. \n" + 
                            "Le taux de la taxe est fixé à 0,6 %. \nCette taxe s’applique aux :\n - locaux à usage de bureaux ;\n - locaux commerciaux ;\n - locaux de stockage. \nCette taxe ne s'applique pas :\n" + 
                            " - aux mutations à titre onéreux soumises à la taxe sur la valeur ajoutée ;\n - aux mutations exonérées de droits d'enregistrement ou de taxe de publicité foncière ;\n" + 
                            " - aux mutations d'immeubles sis hors de la région d'Île-de-France, y compris lorsque les actes translatifs de ces propriétés sont soumis à la formalité de l'enregistrement en Île-de-France ;\n" + 
                            " - aux opérations qui ne constituent pas une vente ou une opération assimilée."
                            }
                        />
                    </div>
                    <div>
                        <ButtonYesno
                            handleChange={handleChange}
                            setter={setTaxeIleDeFrance}
                            fieldUndefined={false}
                            defaultValue={0}
                        />
                    </div>
                </div>
            ) : (
                <>
                    {props.depsZrr.includes(departement) ? (
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>
                            Habitation située dans une zone de revitalisation rurale ? (faisant l'objet d'une réduction de droits)
                        </div>
                        <div>
                            <ButtonYesno handleChange={handleChange} setter={setZrr} fieldUndefined={false} defaultValue={0} />
                        </div>
                    </div>
                    ) : (
                        <></>
                    )}
                </>
            )}
            {props.depsPrimoAccedants.includes(departementChiffre) ? (
                <PrimoAccedant
                    handleChange={handleChange}
                    setPrimoAccedant={setPrimoAccedant}
                />
            ) : (
                <></>
            )}

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                Valeur vénale de l'immeuble :
                <ToolTipPerso
                    title={
                    "Ce prix s'entend hors commission d'agence à la charge du vendeur."
                    }
                />
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setMontantVente}
                />
            </div>
            
            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Quelle est la valeur locative annuelle brute ?
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setValeurLocativeBrute}
                />
            </div>

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Quel est le montant des travaux d'entretien annuels ?
                    <ToolTipPerso
                        title={
                        "Les gros travaux de l’article 606 du Code civil (soit le clos et le couvert), sont à la charge du nu-propriétaire et ne doivent pas être pris en compte."
                        }
                    />
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setTravauxEntretient}
                />
            </div>

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    S'agit-il d'un lot de copropriété ?
                </div>
                <div>
                    <ButtonYesno handleChange={handleChange} setter={setFractionFondTravaux} fieldUndefined={false} defaultValue={0} />
                </div>
            </div>
            {fractionFondTravauxCharges !== 0 ?
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Fraction du fonds de travaux afférente aux charges usufructuaires :
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer le montant"}
                        setter={setFractionFondTravaux}
                    />
                </div>
                : null
            }

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Montant de la taxe foncière :
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setTaxeFonciere}
                />
            </div>

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Montant de la taxe sur les logements vacants (le cas échéant) :
                    <ToolTipPerso
                        title={
                            "En l’absence de cette taxe, indiquer un montant nul."
                        }
                    />
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setTaxeLogementVacant}
                    defaultValue={0}
                />
            </div>

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Est-ce une vente en viager :
                </div>
                <div>
                    <ButtonTextCustom handleChange={handleChange} setter={setTypeViager} defaultValue={0} val1={"Libre"} val2={"Occupé"}/>
                </div>
            </div>
            {typeViager === 1 ?
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        Y a-t-il un usufruit successif ou un droit d’usage successif ?
                        <ToolTipPerso
                            title={
                                "Si l’usufruit ou le DUH commun est réservé par des époux vendeurs, il faut retenir la moitié de la valeur de la pleine propriété et procéder à deux simulations. \n \n" +
                                "Si l’usufruit ou le DUH réservé est indivis, il faut appliquer la quote-part indivise de chaque vendeur à la valeur de la pleine propriété puis procéder à deux simulations. \n \n" +
                                "Dans les cas de deux simulations, pensez à retenir uniquement la part correspondante des charges (la moitié si l'usufruit ou DUH est commun et la quote-part si l'usufruit ou DUH est indivis) pour calculer correctement le taux de rendement net de charges usufructuaires."
                            }
                        />
                    </div>
                    <div>
                        <ButtonYesno handleChange={handleChange} setter={setUsufruitierSuccessif} fieldUndefined={false} defaultValue={0} />
                    </div>
                </div>
                : null
            }

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    {typeViager === 0 ?
                        "Espérance de vie du crédirentier (la plus élevée dans le cas de deux crédirentiers) :" :
                        "Espérance de vie de l’usufruitier ou du titulaire du DUH :"
                    }
                    {usufruitierSuccessif === 1 ? " actuel" : null}
                    <ToolTipPerso
                        title={
                            <>
                                Lien vers le <a href="/categorie/autres/others/118" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer l'espérance de vie.
                            </>
                        }
                    />
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Par ex : 23 pour une femme de 65 ans (INSEE)"}
                    setter={setEsperanceVieUsufruitier}
                />
            </div>

            {usufruitierSuccessif === 1 ? 
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                            Espérance de vie de l’usufruitier ou du titulaire du DUH successif
                        <ToolTipPerso
                            title={
                                <>
                                    Lien vers le <a href="/categorie/autres/others/118" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer l'espérance de vie.
                                </>
                            }
                        />
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer l'espérance de vie"}
                        setter={setEsperanceVieUSSuccessif}
                    />
                </div>
                : null
            }

            <div className="cardRow">
                <div style={styles.cardElemVerticalyCenter}>
                    Montant du bouquet :
                    <ToolTipPerso
                        title={
                            "Le bouquet correspond à la fraction du prix de vente payée comptant et non par le versement d’une rente viagère."
                        }
                    />
                </div>
                <TextfieldNumber
                    handleChange={handleChange}
                    type={"number"}
                    placeholder={"Indiquer le montant"}
                    setter={setMontantBouquet}
                />
            </div>

            {typeViager === 1 ? 
                <div className="cardRow">
                    <div style={styles.cardElemVerticalyCenter}>
                        La vente est-elle assortie d’une réserve :
                    </div>
                    <div>
                        <ButtonTextCustom handleChange={handleChange} setter={setChoixReserveUsage} defaultValue={1} val1={"D'usufruit"} val2={"De DUH"}/>
                    </div>
                </div>
                : null
            }

            {choixReserveUsage === 0 ?
                <div className="cardRow">
                    <div style={styles.cardElemverticalyCenter}>
                        Renseignez la valeur de la nue-propriété fiscale :
                        <ToolTipPerso
                            title={
                                <>
                                Lien vers le <a href="/categorie/autres/others/105" target="_blank" rel="noopener noreferrer">simulateur</a> pour calculer la valeur de la nue-propriété fiscale.
                                </>
                            }
                        />
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Indiquer la valeur"}
                        setter={setValeurFiscalNP}
                        defaultValue={valeurFiscalNP}
                    />
                </div>
                : null
            }

            <Promesse
                handleChange={handleChange}
                setPromesse={setPromesse}
                promesse={promesse}
                setMontantPromesse={setMontantPromesse}
            />

            <DeboursQuestion
                handleChange={handleChange}
                deboursAdditionnels={deboursAdditionnels}
                setDeboursAdditionnels={setDeboursAdditionnels}
                setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
            />
            <Pret
                pretHypo={pretHypo}
                setPretHypo={setPretHypo}
                pretsPro={pretsPro}
                setPretsPro={setPretsPro}
                withPretsProChoice={true}
                setSimu84={setSimu84}
                setSimu92={setSimu92}
                cautionSansGarantieHypo={cautionSansGarantieHypo}
                setCautionSansGarantieHypo={setCautionSansGarantieHypo}
                setSimu114={setSimu114} 
                simulateur={props.simulateur}
                departementId={departement}
                contentDep={setDependancesState}
                handleChange={handleChange}
            />

            <ConventionHonoraires
                handleChange={handleChange}
                conventionHonoraires={props.conventionHonoraires}
                setConventionHonoraires={props.setConventionHonoraires}
                nombreConventionHonoraires={props.nombreConventionHonoraires}
                setNombreConventionHonoraires={props.setNombreConventionHonoraires}
                objectConventionHonoraires={props.objectConventionHonoraires}
                setObjectConventionHonoraires={props.setObjectConventionHonoraires}
                montantConventionHonoraires={props.montantConventionHonoraires}
                setMontantConventionHonoraires={props.setMontantConventionHonoraires}
                nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
                setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
                adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
                setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
            />
        </div>
    </div>
  )
}

export default Simulateur_117;
